export var isServicesOnLocal: boolean = false;
// export var remoteHost: string = "https://dj26cgrfvi.execute-api.us-east-2.amazonaws.com/vts/";
// export var BASE_API_URL: string = (isServicesOnLocal) ? "https://dj26cgrfvi.execute-api.us-east-2.amazonaws.com/vts/" : remoteHost;

// export var remoteHost: string = "http://192.168.1.13:5007/";
// export var BASE_API_URL: string = (isServicesOnLocal) ? "http://192.168.1.13:5007/" : remoteHost;

export var remoteHost: string = "https://api-greenmining.livnsense.com/";
export var BASE_API_URL: string = (isServicesOnLocal) ? "https://api-greenmining.livnsense.com/" : remoteHost;
